module.exports = __webpack_public_path__ + "img/package_10_gray.81627cd2.png";